<template>
  <div style="padding: 15px" class="img-box">
    <el-tabs type="border-card">
      <el-tab-pane label="装货照片">
        <el-image
          :src="fillImageUrl"
        />
      </el-tab-pane>
      <el-tab-pane label="签收照片">
        <el-image
          :src="signImageUrl"
        />
      </el-tab-pane>
      <el-tab-pane label="回单照片">
        <el-image
          :src="ticketImageUrl"
        />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
export default {

  data() {
    return {
      dispatchVisible: false,
      code: '',
      fillImageUrl: '',
      signImageUrl: '',
      ticketImageUrl: '',
      returnRemark: ''
    }
  },
  methods: {
    /* 确定按钮*/
    getInfo(fillImageUrl, signImageUrl, ticketImageUrl) {
      this.fillImageUrl = fillImageUrl
      this.signImageUrl = signImageUrl
      this.ticketImageUrl = ticketImageUrl
    },
    funcCancel() {
      this.$emit('hideModel')
    }
  }
}
</script>
<style>

</style>
